import { dangerColor, successColor } from 'assets/jss/material-dashboard-pro-react';

const toastStyle = () => ({
	card: {
		maxWidth: '75%',
		width: '248px',
		zIndex: 1033,
		position: 'fixed',
		top: 24,
		right: 0,
		boxShadow: 'none!important',
		margin: 0,
		borderRadius: '4px 0 0 4px',
		borderTop: `2px solid ${successColor[0]}`,
		opacity: 0,
		marginRight: '-248px',
		transition: 'margin .5s ease-in-out, opacity .5s ease-in-out',
		minHeight: '56px',
		whiteSpace: 'pre-wrap',
	},
	cardError: {
		borderTop: `2px solid ${dangerColor[0]}`,
	},
	cardBody: {
		padding: '10px 28px 10px 8px',
	},
	close: {
		position: 'absolute',
		right: '4px',
		top: '2px',
		color: '#a4a4a4',
		'& svg': {
			width: '16px',
			height: 'auto',
			cursor: 'pointer',
		},
	},
	actionType: {
		marginBottom: '4px',
	},
	toastActive: {
		marginRight: 0,
		opacity: 1,
		zIndex: 2000,
	},
});

export default toastStyle;
